export function feedbackForm() {
    return {
        step: 1,
        sending: false,
        status: '',
        r: {},

        rc(field, value) {
            return this.r[field] === value
                ? 'bg-primary text-on-primary border-primary'
                : 'border-outline text-on-surface-variant hover:border-on-surface hover:bg-on-surface/8'
        },

        nextStep() {
            this.step++
            window.scrollTo({ top: 0, behavior: 'smooth' })
        },

        prevStep() {
            this.step--
            window.scrollTo({ top: 0, behavior: 'smooth' })
        },

        async submit() {
            this.sending = true
            this.status = ''

            const form = this.$el
            const data = Object.fromEntries(new FormData(form))

            const scale = { 1: 'Незадовільно', 2: 'Потребує покращення', 3: 'Задовільно', 4: 'Добре', 5: 'Чудово' }

            const groups = [
                ['МОНТАЖ І ПРОЄКТУВАННЯ', [
                    ['designConsulting', 'Консультування з дизайну'],
                    ['communication', 'Комунікація під час проєкту'],
                    ['timeliness', 'Своєчасність завершення робіт'],
                    ['quality', 'Якість продукції / робіт'],
                ]],
                ['ОБСЛУГОВУВАННЯ', [
                    ['responseSpeed', 'Швидкість реагування на запити'],
                    ['emergency', 'Реагування на надзвичайні ситуації'],
                    ['modernization', 'Модернізація та ремонт'],
                    ['workQuality', 'Якість проведених робіт'],
                ]],
                ['ЗАГАЛЬНЕ ВРАЖЕННЯ', [
                    ['pricing', 'Ціни'],
                    ['invoicing', 'Виставлення рахунків'],
                    ['managerCommunication', 'Комунікація з менеджерами'],
                    ['professionalism', 'Професіоналізм спеціалістів'],
                ]],
            ]

            let message = ''

            for (const [title, fields] of groups) {
                message += `--- ${title} ---\n`
                for (const [key, label] of fields) {
                    const v = this.r[key]
                    message += v ? `${label}: ${scale[v]} (${v}/5)\n` : `${label}: —\n`
                }
                message += '\n'
            }

            message += '--- ПОРІВНЯЛЬНА ОЦІНКА ---\n'
            message += `Інші постачальники: ${this.r.otherSuppliers || '—'}/10\n`
            message += `Рейтинг СІТІ ЛІФТ: ${this.r.cityLiftRating || '—'}/10\n\n`

            if (data.suggestions) message += `--- ПРОПОЗИЦІЇ ---\n${data.suggestions}\n\n`
            if (data.impressions) message += `--- ВРАЖЕННЯ ---\n${data.impressions}\n\n`
            if (data.location) message += `Розташування ліфта: ${data.location}\n`

            try {
                const res = await fetch(form.action || window.location.href, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: JSON.stringify({
                        subject: 'Зворотний зв\'язок від клієнта',
                        name: data.name,
                        phone: data.phone,
                        email: data.email,
                        message,
                    }),
                })

                const result = await res.json()
                this.status = result.status === 'success' ? 'success' : 'error'

                if (this.status === 'success') {
                    form.reset()
                    this.r = {}
                }
            } catch {
                this.status = 'error'
            } finally {
                this.sending = false
            }
        },
    }
}
